<template>
    <div class="footer">
         <div class="footer-main">
            <p id="footer-title">上海互联网协会</p>
            <div><span>电话 : 021-63323030</span><span>Email : yfchen_iash@163.com</span></div>
            <div><span>地址 : 上海市黄浦区延安东路1200号</span><a>备案号: 沪CP备05000136号</a></div>
         </div>
    </div>
</template>

<script>
export default {
  name: 'examfooter',
  data() {
    return {
    }
  },
}
</script>
<style lang="less" scoped>
  .footer{
  width: 100%;
  height:167px;
  background-color: #003677;
  display: flex;
  justify-content: center;
  border-top: 3px solid #FFC100;
}
.footer-main{
  width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
}
#footer-title{
  font-weight: 600;
  margin-top: 45px;
  letter-spacing: 2px;
}
.footer-main p{
  font-size: 15px;
  margin-top: 10px;
   font-weight: 300;
}
.footer-main div{
  font-size: 13px;
  margin: 15px 0 0 12px;
}
.footer-main div span{
  margin-right: 20px;
  font-weight: 200;
  letter-spacing: 1px;
}
.footer-main div a{
  margin-right: 20px;
  font-weight: 200;
  letter-spacing: 1px;
}
</style>
